import {
  fetchProviderAvailableSlots,
  requestScheduleReschedule,
} from "@/api/providerDashboard";

let nextCandidateId = 0;

function createCandidate() {
  nextCandidateId += 1;
  return {
    id: nextCandidateId,
    date: "",
    time: "",
    slots: [],
    loading: false,
  };
}

export default {
  name: "RescheduleRequestDialog",
  props: {
    visible: { type: Boolean, default: false },
    schedule: { type: Object, default: null },
  },
  data() {
    return {
      candidates: [createCandidate()],
      submitting: false,
      datePickerOptions: {
        disabledDate(date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return date.getTime() < today.getTime();
        },
      },
    };
  },
  watch: {
    visible(isVisible) {
      if (isVisible) {
        this.candidates = [createCandidate()];
      }
    },
  },
  methods: {
    addCandidate() {
      this.candidates.push(createCandidate());
    },
    removeCandidate(index) {
      if (this.candidates.length <= 1) return;
      this.candidates.splice(index, 1);
    },
    async loadSlots(index) {
      const candidate = this.candidates[index];
      candidate.time = "";
      candidate.slots = [];
      if (!candidate.date) return;

      candidate.loading = true;
      try {
        const res = await fetchProviderAvailableSlots(candidate.date);
        candidate.slots = (res.data.data || []).filter(
          (slot) => slot.available
        );
      } catch (error) {
        const responseMessage =
          error.response && error.response.data && error.response.data.message;
        this.$message.error(
          responseMessage || "예약 가능 시간을 불러오지 못했습니다."
        );
      } finally {
        candidate.loading = false;
      }
    },
    async submit() {
      const options = this.candidates.map(({ date, time }) => ({ date, time }));
      if (options.some((option) => !option.date || !option.time)) {
        this.$message.warning("날짜와 시간을 1개 이상 선택해주세요.");
        return;
      }
      const optionKeys = options.map(
        (option) => `${option.date} ${option.time}`
      );
      if (new Set(optionKeys).size !== options.length) {
        this.$message.warning("서로 다른 날짜와 시간을 선택해주세요.");
        return;
      }
      if (!this.schedule || !this.schedule._id) return;

      this.submitting = true;
      try {
        await requestScheduleReschedule(this.schedule._id, { options });
        this.$message.success("고객에게 예약 변경 요청을 보냈습니다.");
        this.$emit("submitted");
      } catch (error) {
        const responseMessage =
          error.response && error.response.data && error.response.data.message;
        this.$message.error(
          responseMessage || "예약 변경 요청을 보내지 못했습니다."
        );
      } finally {
        this.submitting = false;
      }
    },
  },
};
